import styled from 'styled-components';

const Text = styled.div`
  color: ${({ theme }) => theme.text.vulnsInCredentials};
  font-size: 14.5px;
  font-weight: bold;
  cursor: ${({ canRedirect }) => canRedirect ? 'pointer' : 'default'};
`;

export default Text;
